export function normalizeBootstrap(raw) {
  // Retourne un objet avec ces clés, même si vides
  return {
    generatedAt: raw?.generatedAt ?? new Date().toISOString(),
    tasks: {
      list: raw?.tasks?.list ?? [],
      stats: raw?.tasks?.stats ?? {},
      weekly: raw?.tasks?.weekly ?? [],
      operators: raw?.tasks?.operators ?? { day:[], week:[], month:[] },
    },
    sterilization: {
      stats: raw?.sterilization?.stats ?? {},
      weekly: raw?.sterilization?.weekly ?? [],
      categories: raw?.sterilization?.categories ?? [],
      operators: raw?.sterilization?.operators ?? [],
      instruments: raw?.sterilization?.instruments ?? [],
      topInstruments: raw?.sterilization?.topInstruments ?? { day:[], week:[], month:[] },
    },
    operators: raw?.operators ?? { 
      list:[], 
      weekly_hours_by_operator:{}, 
      charts:{day:{},week:{},month:{}}, 
      incidents:{day:{},week:{},month:{}} 
    },
    opsBundle: raw?.opsBundle ?? null,
    activity: raw?.activity ?? {
      operators: [],
      attendance: [],
      lastFetch: null
    },
  };
}